import { Injectable, OnDestroy } from '@angular/core';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { InfoblockFacade } from '../facade';

@Injectable({ providedIn: 'root' })
export class InfoblockPersistenceService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    protected statePersistenceService: StatePersistenceService,
    private infoblockFacade: InfoblockFacade,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'infoblock',
        state$: this.infoblockFacade.getClosedInfoblockIds(),
        storageType: StorageSyncType.SESSION_STORAGE,
        onRead: (state) => this.onRead(state),
      }),
    );
  }

  onRead(closedInfoblocks: string[] | undefined): void {
    if (!closedInfoblocks) {
      return;
    }

    this.infoblockFacade.closeInfoblocks(closedInfoblocks);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
